const pause = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds));

const readPayload = response => response.json().catch(() => ({}));

export async function requestLeagueIntel({ api, path, headers = {}, body }) {
  const response = await fetch(`${api}${path}`, {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify({ ...body, async: true }),
  });
  const payload = await readPayload(response);
  if (!response.ok) throw new Error(payload.detail || 'LeagueIntel is temporarily unavailable.');
  if (response.status !== 202 || !payload.status_url) return payload;

  for (let attempt = 0; attempt < 90; attempt += 1) {
    await pause(1500);
    const statusResponse = await fetch(`${api}${payload.status_url}`, {
      credentials: 'include', headers,
    });
    const statusPayload = await readPayload(statusResponse);
    if (!statusResponse.ok) throw new Error(statusPayload.detail || 'LeagueIntel could not finish the analysis.');
    if (statusPayload.status === 'complete') return statusPayload.result;
  }
  throw new Error('LeagueIntel is still working. Please try again in a moment.');
}
